import React, { type PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@digiwedge/tee-time-ui';
import { WebBrandingProvider } from '@digiwedge/ui-antd';

import { queryClient } from './queryClient.js';

export const TeeTimeAppRoot: React.FC<PropsWithChildren> = ({ children }) => (
  <WebBrandingProvider appName="Tee Time">
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>{children}</BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </WebBrandingProvider>
);

TeeTimeAppRoot.displayName = 'TeeTimeAppRoot';
